import { SxProps, Theme } from '@mui/material/styles';

export const containerStyles = (darkMode: boolean): SxProps<Theme> => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: 0,
  width: '100%',
  maxWidth: '1051px',
  border: '1px solid #DEDEDE',
  borderRadius: '8px',
  backgroundColor: darkMode ? '#1E1E1E' : '#FFFFFF',
  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  marginTop: '16px'
});

export const headerStyles = (darkMode: boolean): SxProps<Theme> => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '8px 16px',
  width: '100%',
  height: '40px',
  backgroundColor: darkMode ? '#2D2D2D' : '#F6F7F2',
  borderBottom: '1px solid #DEDEDE',
  cursor: 'pointer'
});

export const headerTitleStyles = (darkMode: boolean): SxProps<Theme> => ({
  fontFamily: 'Cerebri Sans',
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '24px',
  color: darkMode ? '#FFFFFF' : '#2C2C2C'
});

export const contentStyles: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: '24px',
  width: '100%',
  gap: '24px'
};

export const declarationSectionStyles: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  width: '100%',
  gap: '12px'
};

export const declarationInputStyles = (darkMode: boolean): SxProps<Theme> => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: '12px 16px',
  width: '100%',
  minHeight: '48px',
  backgroundColor: darkMode ? '#2D2D2D' : '#F8F8F2',
  borderRadius: '4px',
  marginBottom: '8px'
});

export const declarationInputFieldStyles = (darkMode: boolean) => ({
  fontFamily: 'Cerebri Sans',
  fontWeight: 700,
  fontSize: '14px',
  lineHeight: '18px',
  color: darkMode ? '#FFFFFF' : '#2C2C2C',
  backgroundColor: 'transparent',
  border: 'none',
  width: '100%'
});

export const textSectionStyles: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: '16px',
  width: '100%',
  border: '1px solid #DEDEDE',
  gap: '8px'
};

export const textSectionTitleStyles = (darkMode: boolean): SxProps<Theme> => ({
  fontFamily: 'Cerebri Sans',
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '24px',
  color: darkMode ? '#FFFFFF' : '#2C2C2C'
});

export const textInputRowStyles = (darkMode: boolean): SxProps<Theme> => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '12px 16px',
  width: '100%',
  minHeight: '46px',
  backgroundColor: darkMode ? '#2D2D2D' : '#F8F8F2',
  borderRadius: '4px',
  marginBottom: '4px'
});


export const iconButtonStyles: SxProps<Theme> = {
  color: (theme) => theme.palette.mode === 'dark' ? '#FFFFFF' : '#2C2C2C'
};

export const fullWidthBoxStyles: SxProps<Theme> = {
  width: '100%'
};

export const textSectionContainerStyles: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: '16px',
  width: '100%',
  border: '1px solid #DEDEDE',
  borderRadius: '4px',
  gap: '12px',
  marginTop: '16px'
};

export const textInputFieldsContainerStyles: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  width: '100%',
  gap: '4px'
};

export const textInputContentStyles: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '16px',
  flex: 1
};

export const inputFieldLabelStyles = (darkMode: boolean, minWidth: string): SxProps<Theme> => ({
  fontFamily: 'Cerebri Sans',
  fontSize: '14px',
  lineHeight: '18px',
  color: darkMode ? '#FFFFFF' : '#2C2C2C',
  minWidth: minWidth,
  display: 'flex',
  alignItems: 'center'
});

export const inputFieldContainerStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  flex: 1
};

export const inputFieldContainerWithoutFlexStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px'
};

export const asteriskStyles: SxProps<Theme> = {
  color: '#C81E24',
  fontSize: '16px',
  fontWeight: 600
};

export const deleteButtonStyles: SxProps<Theme> = {
  padding: "5px",
  border: "1px solid #D9CEC1",
  borderRadius: "0",
};

export const declarationLabelStyles = (darkMode: boolean): SxProps<Theme> => ({
  fontFamily: 'Cerebri Sans',
  fontWeight: 700,
  fontSize: '14px',
  lineHeight: '18px',
  color: darkMode ? '#FFFFFF' : '#2C2C2C',
  minWidth: '80px',
  marginRight: '8px'
});

export const declarationValueStyles = (darkMode: boolean): SxProps<Theme> => ({
  fontFamily: 'Cerebri Sans',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '18px',
  color: darkMode ? '#FFFFFF' : '#2C2C2C',
  flex: 1
});
